module.exports = __webpack_public_path__ + "static/img/active_vip_10.d17e238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/activity/active_vip_10.jpg
// module id = RsqH
// module chunks = 0